export const sendCaseClosureRequest = async (apiClient, data) => {
    return apiClient.request("/servicecall/proactivecaseclosure", { body: data });
};
//# sourceMappingURL=sendCaseClosureRequest.js.map
